module.exports = __webpack_public_path__ + "static/media/elheraldo.5723fbb1.png";